import React from "react";

function WidthIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="10"
      viewBox="0 0 25 10"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g
          fill="currentColor"
          fillRule="nonzero"
          transform="rotate(90 12 12.5)"
        >
          <path d="M8.504 18.748a.563.563 0 00-.796 0l-2.411 2.434V2.818l2.411 2.434c.22.22.576.22.796 0l.331-.332a.562.562 0 000-.795L4.898.165a.563.563 0 00-.796 0L.165 4.125a.562.562 0 000 .795l.331.332c.22.22.576.22.796 0l2.411-2.434v18.364l-2.411-2.434a.563.563 0 00-.796 0l-.331.331a.562.562 0 000 .796l3.937 3.96c.22.22.576.22.796 0l3.937-3.96a.562.562 0 000-.796l-.331-.33z"></path>
        </g>
      </g>
    </svg>
  );
}

export default WidthIcon;
